import { 
  SET_BONDS_RESPONSE, 
  SET_CONDITIONS_RESPONSE, 
  SET_STRENGTHS_RESPONSE,
  SET_STRENGTH_VALUE,
  SET_SPINNER,
  SET_MASONRY_TYPES_RESPONSE,
  RESET_WEB_MATERIAL_STATE,
  SET_WEB_MATERIAL_STATE } from './actions';
import { mergeDeep } from '@services/helper.service';

const initState = {
    bonds: [],
    conditions: [],
    strengths: [],
    concreteStrengthValue: 0,
    isPending: true,
    masonryTypes: []
};

const material = (state = initState, action) => {
  switch (action.type) {
    case SET_BONDS_RESPONSE: {
        if (state.bonds !== action.value){
            return mergeDeep({}, state, {
              bonds: action.value
            });
        }
        else 
            return state;
    }
    case SET_CONDITIONS_RESPONSE: {
      return mergeDeep({}, state, {
        conditions: action.value
      });
    }
    case SET_STRENGTHS_RESPONSE: {
      return mergeDeep({}, state, {
        strengths: action.value
      });
    }
    case SET_STRENGTH_VALUE: {
      return mergeDeep({}, state, {
        concreteStrengthValue: action.value
      });
    }
    case SET_SPINNER: {
      return mergeDeep({}, state, {
        isPending: action.value
      });
    }
    case SET_MASONRY_TYPES_RESPONSE: {
      return mergeDeep({}, state, {
        masonryTypes: action.value
      });
    }
    case RESET_WEB_MATERIAL_STATE: {
      return mergeDeep({}, initState);
    }
    case SET_WEB_MATERIAL_STATE: {
      return action.state;
    }
    default: {
      return state;
    }
  }
};

export default material;



// WEBPACK FOOTER //
// ./src/reducers/web-services/material/index.js